import { CopyButton } from '../copy-button';
import { QrCodeDownloadButton } from '../qr-code-download-button';
import { cn } from '@/lib/tailwind-utils';

interface StudentShortLinkProps {
  shortCode: string | null;
  fullLink?: boolean;
  isActive?: boolean;
  className?: string;
  linkTestId?: string;
  copyButtonTestId?: string;
  downloadButtonTestId?: string;
  emptyTestId?: string;
}

export const StudentShortLink = ({
  shortCode,
  fullLink = false,
  isActive = true,
  className,
  linkTestId,
  copyButtonTestId,
  downloadButtonTestId,
  emptyTestId,
}: StudentShortLinkProps) => {
  if (!shortCode) {
    return <span data-testid={emptyTestId}>-</span>;
  }

  const fullLinkUrl = `${import.meta.env.VITE_JOIN_NOW_URL}/${shortCode}`;
  const baseUrl = fullLinkUrl.substring(0, fullLinkUrl.lastIndexOf('/') + 1);
  const code = fullLinkUrl.substring(fullLinkUrl.lastIndexOf('/') + 1);

  return (
    <div className={cn('flex items-center min-w-0', className)}>
      <div className="min-w-0 flex-1">
        <a
          href={fullLinkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            'pointer-events-none no-underline font-mono',
            isActive ? 'text-black' : 'text-gray-500 line-through decoration-gray-400',
          )}
          aria-disabled={!isActive}
          data-testid={linkTestId}
        >
          {fullLink ? (
            <div className="flex flex-col">
              <span className="truncate">{baseUrl}</span>
              <span className="truncate">{code}</span>
            </div>
          ) : (
            <span className="whitespace-nowrap">{`go/${shortCode}`}</span>
          )}
        </a>
      </div>
      {isActive && (
        <div className="flex items-center gap-1 flex-shrink-0">
          <CopyButton content={fullLinkUrl} buttonProps={{ 'data-testid': copyButtonTestId }} />
          <QrCodeDownloadButton
            url={fullLinkUrl}
            filename={`qrcode-${shortCode}.png`}
            format="png"
            buttonProps={{ className: 'flex-shrink-0', 'data-testid': downloadButtonTestId }}
          />
        </div>
      )}
    </div>
  );
};
